import { SBCAAS_MODERN_LABEL } from '@/constants/sbcaas';
import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../../walkthroughIds';
import FieldToolTip from 'components/forms/new/FieldToolTip';

/**
 * Trunk types on an SRT profile.
 *
 * SRT offers a single trunk type, so unlike the SBCaaS equivalent this is shown
 * read-only — the value is set for the user and cannot be added to or removed
 * (2240). The validate still runs so a missing SRT trunk type surfaces as a
 * form error rather than a save that silently omits it.
 */
const SRTTrunkTypesField = ({ options, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{
                    ...stackStyling(true),
                    height: 'auto',
                    minHeight: '75px',
                }}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Trunk Types <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        {SBCAAS_MODERN_LABEL} profiles use a single trunk type,
                        set automatically.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <Field
                                name="trunkTypes"
                                validate={(value) =>
                                    (!value || value.length === 0) &&
                                    `No ${SBCAAS_MODERN_LABEL} trunk type is available.`
                                }>
                                {({ field, meta }) => (
                                    <>
                                        <DropDown
                                            name="trunkTypes"
                                            isMulti
                                            readOnly
                                            data={options}
                                            shownValue="name"
                                            multiValue={
                                                Array.isArray(field.value)
                                                    ? field.value.map(
                                                          (item) => item.id,
                                                      )
                                                    : []
                                            }
                                            walkthroughId={
                                                walkthroughIds.serviceProfiles
                                                    ?.ufTrunkTypesSelect
                                            }
                                            placeholder="- No trunk type available -"
                                            darkMode={darkMode}
                                            width="100%"
                                            noPadding
                                            handleSelectChange={() => {}}
                                        />
                                        {meta.touched && meta.error && (
                                            <Text
                                                color="red.500"
                                                fontSize="xs"
                                                mt={1}
                                                textAlign="right">
                                                {meta.error}
                                            </Text>
                                        )}
                                    </>
                                )}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label={`${SBCAAS_MODERN_LABEL} offers a single trunk type, so this cannot be changed.`}
                        ariaLabel="srt-trunk-types-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default SRTTrunkTypesField;
